import type { Workitem } from '@rhythmic/db/types'
import type { CreateWorkitemPayload, KanbanWorkitemMutationPayload } from '@rhythmic/types'
import type { Transaction } from '@tanstack/vue-db'
import type { Ref } from 'vue'
import { toValue } from 'vue'
import { handleUpdateWorkitem } from '../kanbanBoard/useKanbanBoardContext.updateWorkitem'
import type { BacklogContext } from './useBacklogContext'
import { handleCreateWorkitem } from './useBacklogContext.createWorkitem'
import { handleDeleteWorkitem } from './useBacklogContext.deleteWorkitem'

export default function createMutationHandlers(context: Ref<BacklogContext | undefined>) {
  return {
    createWorkitem: (payload: CreateWorkitemPayload): Transaction<Workitem> => {
      return handleCreateWorkitem(payload, toValue(context))
    },
    deleteWorkitem: (id: string): Transaction<Workitem> => {
      return handleDeleteWorkitem(id, toValue(context))
    },
    updateWorkitem: (payload: KanbanWorkitemMutationPayload): Transaction => {
      const resolvedContext = toValue(context)
      if (!resolvedContext) throw new Error('Backlog context is not ready: missing team context')

      return handleUpdateWorkitem(
        payload,
        toValue({
          boardId: 'not-used-in-backlog-context',
          workspaceId: resolvedContext.workspaceId,
          teamId: resolvedContext.teamId,
          packageId: 'not-used-in-backlog-context',
        }),
      )
    },
  }
}
